import React, { Component } from 'react';

import { Col, Row, Button, Container, Table}  from 'react-bootstrap';
import { FaPen, FaTrash } from 'react-icons/fa';
import {Rest} from "../../Helpers/Rest" 
import {check_roles} from "../../Helpers/Roles" 
import InfoBlock from "../../Components/InfoBlock/InfoBlock"
var moment = require('moment'); // require
export default class List extends Component {
  state = {}

  componentDidMount = () => {
    this.load()
  };

  load = () => {
    var rest = new Rest(this)
    rest.request("users", "GET", {}, (res)=>{ 
      this.setState({
        data: res
      })
    })
  }

  delete = (id) => {
    var rest = new Rest(this)
    rest.request("users", "DELETE", {id:id}, (res)=>{
      this.load()
    })
  }
  
  render() {
    console.log(this.state)
    return (
      <Container>
          <Row className="mt-3 mb-3">
            <Col>
                <h4>All feedback categories of your company</h4>
            </Col>
          </Row>

          {
            this.state.errors && <InfoBlock data={this.state.errors} variant="danger" />
          }
          <Row>
              <Col>
                  <a className="btn btn-outline-primary m-1" href="/users/create">Add user</a>
                  <Table>
                      <thead>
                          <tr>
                              <th>ID</th>
                              <th>name</th>  
                              <th>status</th>  
                              <th>position</th>  
                              <th>department</th>   
                          </tr>
                      </thead>
                      <tbody>
                          {
                            this.state.data && this.state.data.length && this.state.data.map(el=>{
                              return (
                                <tr key={el.id}>
                                  <td><a href={"/users/edit/"+el.id}>{el.id} <FaPen size={13} title="edit" /></a> </td> 
                                  <td>{el.name}</td>  
                                  <td>{el.status}</td>  
                                  <td>{el.position}</td>  
                                  <td>{el.department}</td>  
                                </tr>
                              )
                            })
                          }
                      </tbody>
                  </Table>
              </Col>
          </Row>
          
      </Container>
    );
  }
}
